import React from "react";
import Intro from "./components/Header/Intro/Intro";
import classes from "./styles.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-scroll";
import About from "./components/About/About";
import Top from "./components/Top Button/Top";
import Projects from "./components/Projects/Projects";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Blogs from "./components/Blogs/Blogs";
import BlogsComingSoon from "./components/Blogs/BlogsComingSoon";

const App = () => {
  const openNav = (e) => {
    e.preventDefault();
    document.getElementById("myNav").style.height = "100%";
    document.getElementById("menu").style.fontSize = "0px";
  };
  const closeNav = (e) => {
    e.preventDefault();
    document.getElementById("myNav").style.height = "0%";
    document.getElementById("menu").style.fontSize = "30px";
  };
  return (
    <div className={classes.App}>
      <div id="myNav" className={classes.overlay}>
        <a
          className={classes.alink}
          style={{ cursor: "pointer" }}
          className={classes.closebtn}
          onClick={closeNav}
        >
          &times;
        </a>
        <div className={classes.overlayContent}>
          <Link
            onClick={closeNav}
            activeClass="active"
            to={classes.about}
            spy={true}
            smooth={true}
            offset={-40}
            duration={800}
          >
            About Me
          </Link>
          <br />

          <Link
            onClick={closeNav}
            activeClass="active"
            to={classes.procon}
            spy={true}
            smooth={true}
            offset={-40}
            duration={800}
          >
            Projects
          </Link>
          <br />
          <Link
            onClick={closeNav}
            activeClass="active"
            to={classes.blogs}
            spy={true}
            smooth={true}
            offset={-40}
            duration={800}
          >
            Blogs
          </Link>
          <br />

          <Link
            onClick={closeNav}
            activeClass="active"
            to={classes.contactScroll}
            spy={true}
            smooth={true}
            offset={-40}
            duration={800}
          >
            Contact
          </Link>
        </div>
      </div>
      <div className={classes.header}>
        <span className={classes.resume1}>
          <a
            href="https://drive.google.com/file/d/1Wx4DPqw-uEyJbH1bsdiHwEOblsEifCRc/view?usp=sharing"
            target="blank"
            style={{ textDecoration: "none", color: "black" }}
          >
            VIEW RESUME
          </a>
        </span>
        <span id="menu" className={classes.menu} onClick={openNav}>
          &#9776;
        </span>
      </div>
      <Intro />
      <div className={classes.about}> About Me</div>
      <About />
      <div className={[classes.about, classes.procon].join(" ")}>Projects</div>
      <Projects />
      <div className={[classes.about, classes.procon, classes.blogs].join(" ")}>
        Blogs Are Coming Soon
      </div>
      <BlogsComingSoon />
      <div
        className={[
          classes.skills,
          classes.contactScroll,
          classes.blogs,
          classes.procon,
        ].join(" ")}
      >
        Contact
      </div>
      <Contact />
      <Footer />
      <Top />
    </div>
  );
};

export default App;
